// extracted by mini-css-extract-plugin
export default {"container":"OrgTable_container__x2Eq9","table":"OrgTable_table__uY7RA","delete":"OrgTable_delete__rkFh8","not-implemented":"OrgTable_not-implemented__labIm"};